// Actions types
export const GET_INSURERS_REPORTS = 'searchReport';
export const DOWNLOAD_INSURERS_REPORTS = 'downloadReport';

// Mutations types
export const SET_INSURERS_REPORTS_ERRORS = 'setInsurersReportsErrors';
export const SET_INSURERS_REPORTS_LOADING = 'setInsurersReportsLoading';
export const SET_INSURERS_REPORTS = 'setInsurersReports';

// Getters types
export const INSURERS_REPORTS_ERRORS = 'insurersReportsErrors';
export const INSURERS_REPORTS_LOADING = 'insurersReportsLoading';
export const INSURERS_REPORTS_LIST = 'insurersReportsList';
